import './WhatsAppButton.css';

const PHONE_NUMBER = '919003069189';
const MESSAGE =
  'Hello,\nI would Like to know more about your *Shrekruthi Phytoceuticals* service.';

function WhatsAppButton() {
  const href = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <a
      href={href}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor">
        <path d="M16.01 3C9.38 3 4 8.38 4 15.01c0 2.3.64 4.45 1.75 6.29L4 29l7.9-1.7a11.9 11.9 0 0 0 4.11.73h.01C22.65 28.03 28 22.65 28 16.02 28 9.38 22.64 3 16.01 3Zm0 21.83h-.01a9.8 9.8 0 0 1-5-1.37l-.36-.21-4.69 1.01 1.02-4.57-.24-.38a9.77 9.77 0 0 1-1.5-5.3c0-5.4 4.4-9.8 9.8-9.8 2.62 0 5.08 1.02 6.93 2.87a9.73 9.73 0 0 1 2.87 6.93c0 5.4-4.4 9.8-9.8 9.8Zm5.37-7.34c-.29-.15-1.74-.86-2.01-.96-.27-.1-.47-.15-.66.15-.2.29-.76.96-.93 1.16-.17.2-.34.22-.63.07-.29-.15-1.23-.45-2.34-1.44-.86-.77-1.45-1.71-1.61-2-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.5-.66-.51h-.56c-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44s1.05 2.83 1.19 3.03c.15.2 2.07 3.16 5.02 4.43.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.12.56-.08 1.74-.71 1.99-1.4.24-.68.24-1.27.17-1.4-.07-.12-.27-.2-.56-.35Z" />
      </svg>
    </a>
  );
}

export default WhatsAppButton;
